import { render } from "./InstrucoesCarregamentoPedidosExpedidoFaturado.vue?vue&type=template&id=122612c2&scoped=true"
import script from "./InstrucoesCarregamentoPedidosExpedidoFaturado.vue?vue&type=script&lang=js"
export * from "./InstrucoesCarregamentoPedidosExpedidoFaturado.vue?vue&type=script&lang=js"

import "./InstrucoesCarregamentoPedidosExpedidoFaturado.vue?vue&type=style&index=0&id=122612c2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122612c2"]])

export default __exports__